export class BrandModel {
    public BrandId:number;
    public Name:string;
    public IsFood:boolean;

    public BrandAutoComplete:any;
    public Brandlist:BrandModel[];
}
